import React from 'react';
import './header.scss';
import SocialPanel from './socialpanel/socialpanel.jsx';
import CTopMenu from './topmenu/ctopmenu.js';

class Header extends React.Component {
  constructor(props) {
    super(props);
  };

  componentWillMount() {};

  render() {
    return (
      <header className='header-wrap'>
        <SocialPanel />
        <CTopMenu />
      </header>
    );
  };
};

export default Header;



// WEBPACK FOOTER //
// ./src/client/components/header/header.jsx